// ****************************************************************************************************************************************************
// Utility function to determine whether a given URL belongs to the current domain (local) or is external

export function isLocalUrl(urlToCheck) {
  return urlToCheck !== null && urlToCheck.includes(SITEBASEURL);
}

// ****************************************************************************************************************************************************
// Utility function to add target attribute to external links

export function getLinkTargetAttr(isLocal) {
  return isLocal ? '' : 'target="_blank"';
}
